export default "__VITE_ASSET__BUz5yvvd__"